export const ELITE_DEALS_GOLD = "#edb100";
